export enum ShiftDrawerCollapseSectionEnum {
  ShiftDetails = 'shiftDetails',
  ShiftContents = 'shiftContents',
  Activities = 'activities',
  Attachments = 'attachments',
  Staff = 'staff',
  WageData = 'wageData',
  PayrollTransactions = 'payrollTransactions',
  PayrollNote = 'payrollNote',
  QuickCheck = 'quickCheck',
  ShiftFeatures = 'shiftFeatures',
}

export const ShiftDrawerCollapseDefaultSettings: Record<
  ShiftDrawerCollapseSectionEnum,
  boolean
> = {
  [ShiftDrawerCollapseSectionEnum.ShiftDetails]: true,
  [ShiftDrawerCollapseSectionEnum.ShiftContents]: false,
  [ShiftDrawerCollapseSectionEnum.Activities]: false,
  [ShiftDrawerCollapseSectionEnum.Attachments]: false,
  [ShiftDrawerCollapseSectionEnum.Staff]: false,
  [ShiftDrawerCollapseSectionEnum.WageData]: false,
  [ShiftDrawerCollapseSectionEnum.PayrollTransactions]: false,
  [ShiftDrawerCollapseSectionEnum.PayrollNote]: true,
  [ShiftDrawerCollapseSectionEnum.QuickCheck]: true,
  [ShiftDrawerCollapseSectionEnum.ShiftFeatures]: false,
};
